// extracted by mini-css-extract-plugin
export default {"eventCardLink":"EventCard_eventCardLink__Mybvx","shineLoop":"EventCard_shineLoop__8c1Sd"};